import { render, staticRenderFns } from "./EditSpokespersonModal.vue?vue&type=template&id=3055d157&"
import script from "./EditSpokespersonModal.vue?vue&type=script&lang=js&"
export * from "./EditSpokespersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports